import regions from "./regions";
import regionsStaging from "./regions.staging";

export const regionsEnv = {
  local: regionsStaging,
  staging: regionsStaging,
  production: regions,
};

const regionsList = regionsEnv[process.env.VUE_APP_ENV] ?? regionsEnv.production;

export default regionsList;